export default __webpack_public_path__ + "static/media/profile.cda6d22c.png";